/* Constants */

import { handleResponse } from './api/apiUtils'
import * as urls from './api/urls'
import { SET_CURRENT_PROPERTY } from './properties'

export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS'
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE'
export const CREATE_ORDER_RESET = 'CREATE_ORDER_RESET'

const initialState = {
    orderCreated: false
}

/* Reducers */

/** @reducer **/
export const createOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_PROPERTY:
            return initialState
        case CREATE_ORDER_SUCCESS:
            return { orderCreated: true, error: null }
        case CREATE_ORDER_FAILURE:
            return { orderCreated: true, error: action.payload.error }
        case CREATE_ORDER_RESET:
            return { orderCreated: false, error: null }
        default:
            return state
    }
}

export const createOrder = payload => (dispatch, getState) => {
    const { secretKey, properties } = getState()
    const { currentProperty } = properties

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
    }

    return fetch(urls.createOrderUrl(secretKey, currentProperty), opts)
        .then(handleResponse)
        .then(json => {
            if (json && json.redirectUrl) setTimeout(() => {
                window.location = json.redirectUrl
            }, 1000)
            dispatch(orderCreateSuccess())
        })
        .catch(err => dispatch(orderCreateFailure(err)))
}

export const resetOrderCreated = () => dispatch => {
    dispatch(orderCreateReset())
}

/** @action **/
export const orderCreateSuccess = () => ({
    type: CREATE_ORDER_SUCCESS
})

/** @action **/
export const orderCreateFailure = error => ({
    type: CREATE_ORDER_FAILURE,
    payload: { error }
})

/** @action **/
export const orderCreateReset = () => ({
    type: CREATE_ORDER_RESET
})



// WEBPACK FOOTER //
// ./modules/createOrder.js